import { useEffect, useState } from "react";
import ComicModel from "../../models/ComicModel";
import ReviewModel from "../../models/ReviewModel";
import { LoadingSpinner } from "../utils/LoadingSpinner";
import { StarsReview } from "../utils/Stars/StarsReview";
import { CheckoutAndReviewBox } from "./CheckoutAndReviewBox";
import { LatestReviews } from "./LatestReviews";

import { config } from './../../Constants'

export const CheckoutComicPage = () => {
	

	// Comic State
	const [comic, setComic] = useState<ComicModel>();
	const [isLoading, setIsLoading] = useState(true);
	const [httpError, setHttpError] = useState(null);

	// Review State
	const [reviews, setReviews] = useState<ReviewModel[]>([]);
	const [totalStars, setTotalStars] = useState(0);
	const [isLoadingReview, setIsLoadingReview] = useState(true);

	const comicId = window.location.pathname.split("/")[2];

	const API_BASE_URL = config.url.API_HOST

	useEffect(() => {
		const fetchComic = async () => {
			const baseUrl: string = `${API_BASE_URL}/api/comics/${comicId}`;
			
			const response = await fetch(baseUrl);

			if (!response.ok) {
				console.log("ERROR");
				console.log("Error 1")
				throw new Error("Something went wrong!");
			}

			const responseJson = await response.json();

			console.log(responseJson);

			const loadedComic: ComicModel = {
				id: responseJson.id,
				db_id: responseJson.db_id,
				title: responseJson.title,
				author: responseJson.author,
				description: responseJson.description,
				copies: responseJson.copies,
				copiesAvailable: responseJson.copiesAvailable,
				category: responseJson.category,
				img: responseJson.img,
				published: responseJson.published,
			};

			setComic(loadedComic);
			setIsLoading(false);
		};

		fetchComic().catch((error: any) => {
			setIsLoading(false);
			setHttpError(error.message);
		});
	}, []);


	useEffect(() => {
		const fetchComicReviews = async () => {
			const baseUrl: string = `${API_BASE_URL}/api/reviews/search/findByComicId?comicId=${comicId}`;

			const response = await fetch(baseUrl);

			if (!response.ok) {
				console.log("ERROR");
				console.log("error 2")
				throw new Error("Something went wrong!");
			}

			const responseJson = await response.json();
			const responseData = responseJson._embedded.reviews;

			console.log(responseJson);

			const loadedComicReviews: ReviewModel[] = [];

			let starReviewsSum: number = 0;

			responseData.map((item: ReviewModel) => {
				loadedComicReviews.push(item);
				starReviewsSum = starReviewsSum + item.rating;
			});

			if (loadedComicReviews) {
				const round = (Math.round((starReviewsSum / loadedComicReviews.length) * 2) / 2).toFixed(1);
				setTotalStars(Number(round));
			}

			setReviews(loadedComicReviews);
			setIsLoadingReview(false);
		};

		fetchComicReviews().catch((error: any) => {
			setIsLoading(false);
			setHttpError(error.message);
		});
	}, []);



	if (isLoading || isLoadingReview) {
		return <LoadingSpinner></LoadingSpinner>;
	}

	
	if (httpError) {
		return (
			<div className="container m-5">
				<p>{httpError}</p>
			</div>
		);
	}

	return (
		<div>
			{/* DESKTOP */}
			<div className="container d-none d-lg-block">
				<div className="row mt-5">
					<div className="col-sm-2 col-md-2">
						{comic?.img ? (
							<img
								src={comic?.img}
								width="226"
								height="349"
								alt="Comic"
							/>
						) : (
							<img
								width="226"
								height="349"
								alt="Comic"
								src={require("./../../Images/CoverImages/notFound.png")}
							></img>
						)}
					</div>

					<div className="col-4 col-md-4 container">
						<div className="ml-2">
							<h2>{comic?.title}</h2>
							<h5 className="text-primary">{comic?.author}</h5>
							<p className="lead">{comic?.description}</p>
                            <StarsReview rating={totalStars} size={32}></StarsReview>
							<p className="lead m-1">Rating Average: {totalStars > 0 ? totalStars : "None"}</p>
						</div>
					</div>

                    <CheckoutAndReviewBox comic={comic} mobile={false}></CheckoutAndReviewBox>
				</div>
				<hr></hr>
				<LatestReviews reviews={reviews} comicId={comic?.id} mobile={false}></LatestReviews>
			</div>

			{/* MOBILE */}
			<div className="container d-lg-none mt-5">
				<div className="d-flex justify-content-center align-items-center">
					{comic?.img ? (
						<img
							src={comic?.img}
							width="226"
							height="349"
							alt="Comic"
						/>
					) : (
						<img
							width="226"
							height="349"
							alt="Comic"
							src={require("./../../Images/CoverImages/notFound.png")}
						></img>
					)}
				</div>
				<div className="mt-4">
					<div className="ml-2">
						<h2>{comic?.title}</h2>
						<h5 className="text-primary">{comic?.author}</h5>
						<p className="lead">{comic?.description}</p>
					</div>
				</div>
                <CheckoutAndReviewBox comic={comic} mobile={true}></CheckoutAndReviewBox>
                <hr></hr>
				<LatestReviews reviews={reviews} comicId={comic?.id} mobile={true}></LatestReviews>
			</div>
            
		</div>
	);
};
